import { useContext, useCallback } from 'react';

import { CloseDialogContext } from '../context';
import { NO_RESULT } from '../types';

export const useCloseDialog = <RESULT>() => {
  const closeDialogFn = useContext(CloseDialogContext);
  return useCallback(
    (result?: RESULT) => closeDialogFn(result ?? NO_RESULT),
    [closeDialogFn]
  );
};
